"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Organization_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Organization = void 0;
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const Person_1 = require("./Person");
const schema_1 = require("../ontologies/schema");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const Thing_1 = require("./Thing");
const ShapeSet_1 = require("lincd/lib/collections/ShapeSet");
let Organization = Organization_1 = class Organization extends Thing_1.Thing {
    get faxNumber() {
        return this.getValue(schema_1.schema.faxNumber);
    }
    set faxNumber(val) {
        this.overwrite(schema_1.schema.faxNumber, new models_1.Literal(val));
    }
    get email() {
        return this.getValue(schema_1.schema.email);
    }
    set email(val) {
        this.overwrite(schema_1.schema.email, new models_1.Literal(val));
    }
    get legalName() {
        return this.getValue(schema_1.schema.legalName);
    }
    set legalName(val) {
        this.overwrite(schema_1.schema.legalName, new models_1.Literal(val));
    }
    get address() {
        return this.getValue(schema_1.schema.address);
    }
    set address(val) {
        this.overwrite(schema_1.schema.address, new models_1.Literal(val));
    }
    get telephone() {
        return this.getValue(schema_1.schema.telephone);
    }
    set telephone(val) {
        this.overwrite(schema_1.schema.telephone, new models_1.Literal(val));
    }
    static getAffiliationsOf(person) {
        return person.getAllAs(schema_1.schema.affiliation, Organization_1);
    }
    static setAffiliation(person, org) {
        person.set(schema_1.schema.affiliation, org.namedNode);
    }
    get members() {
        return Person_1.Person.getSetOf(this.getAll(schema_1.schema.members));
    }
    get founder() {
        return this.getOneAs(schema_1.schema.founder, Person_1.Person);
    }
    set founder(val) {
        this.overwrite(schema_1.schema.founder, val ? val.node : null);
    }
};
exports.Organization = Organization;
Organization.targetClass = schema_1.schema.Organization;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.faxNumber,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Organization.prototype, "faxNumber", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.email,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Organization.prototype, "email", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.legalName,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Organization.prototype, "legalName", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: schema_1.schema.telephone,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Organization.prototype, "telephone", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.members,
        shape: Person_1.Person,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], Organization.prototype, "members", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: schema_1.schema.founder,
        shape: Person_1.Person,
        maxCount: 1,
    }),
    __metadata("design:type", Person_1.Person),
    __metadata("design:paramtypes", [Person_1.Person])
], Organization.prototype, "founder", null);
exports.Organization = Organization = Organization_1 = __decorate([
    package_1.linkedShape
], Organization);
//# sourceMappingURL=Organization.js.map